import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-row justify-content-center"
}
const _hoisted_2 = { class: "border rounded bg-white px-3 py-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-3" }, "Данные пользователя", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Номер телефона")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Укажите номер телефона пользователя ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Имя")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Укажите имя пользователя ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Группы пользователя")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_11 = { class: "border rounded bg-white px-3 py-3 mt-3" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Пароль должен содержать не меньше 8 символов ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Пароли не совпадают ")
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "mt-4 mb-5" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Сохранить ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CSpinner = _resolveComponent("CSpinner")!
  const _component_CCol = _resolveComponent("CCol")!
  const _component_CRow = _resolveComponent("CRow")!
  const _component_CFormLabel = _resolveComponent("CFormLabel")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_CFormFeedback = _resolveComponent("CFormFeedback")!
  const _component_CFormCheck = _resolveComponent("CFormCheck")!
  const _component_CFormSwitch = _resolveComponent("CFormSwitch")!
  const _component_CFormInput = _resolveComponent("CFormInput")!
  const _component_BIconEyeFill = _resolveComponent("BIconEyeFill")!
  const _component_BIconEyeSlashFill = _resolveComponent("BIconEyeSlashFill")!
  const _component_CButton = _resolveComponent("CButton")!
  const _component_CInputGroup = _resolveComponent("CInputGroup")!
  const _component_CIcon = _resolveComponent("CIcon")!
  const _component_CAlert = _resolveComponent("CAlert")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_CSpinner)
      ]))
    : (_openBlock(), _createElementBlock("form", {
        key: 1,
        onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveUser && _ctx.saveUser(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_CRow, null, {
            default: _withCtx(() => [
              _createVNode(_component_CCol, { md: "3" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_CRow, null, {
            default: _withCtx(() => [
              _createVNode(_component_CCol, { md: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_CFormLabel, null, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_AppInput, {
                    type: "text",
                    "auto-unmask": false,
                    invalid: _ctx.user.loginInvalid,
                    mask: _ctx.phoneMask,
                    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.user.loginInvalid = false)),
                    modelValue: _ctx.user.login,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.login) = $event))
                  }, null, 8, ["invalid", "mask", "modelValue"]),
                  _createVNode(_component_CFormFeedback, { invalid: "" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_CCol, { md: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_CFormLabel, null, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_AppInput, {
                    type: "text",
                    invalid: _ctx.user.nameInvalid,
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.user.nameInvalid = false)),
                    modelValue: _ctx.user.name,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.name) = $event))
                  }, null, 8, ["invalid", "modelValue"]),
                  _createVNode(_component_CFormFeedback, { invalid: "" }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_CRow, { class: "mt-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_CCol, { md: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_CFormLabel, null, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _hoisted_9,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userRolesOptions, (role) => {
                    return (_openBlock(), _createBlock(_component_CFormCheck, {
                      key: role,
                      inline: "",
                      value: role.value,
                      label: role.label,
                      disabled: role.disabled,
                      id: `userRoleOption_${role.value}`,
                      onInput: _cache[4] || (_cache[4] = (e) => _ctx.onRoleChanged(e.target)),
                      checked: _ctx.user.roles.indexOf(role.value) !== -1
                    }, null, 8, ["value", "label", "disabled", "id", "checked"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.user.id !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_CFormSwitch, {
                  label: "Заблокирован",
                  id: "userIsBlockedSwitch",
                  onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.user.isBlocked = $event.target.checked)),
                  checked: _ctx.user.isBlocked,
                  size: "lg"
                }, null, 8, ["checked"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_CRow, null, {
            default: _withCtx(() => [
              _createVNode(_component_CCol, { md: "3" }, {
                default: _withCtx(() => [
                  _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.isEditing ? 'Смена' : 'Установка') + " пароля", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_CRow, null, {
            default: _withCtx(() => [
              _createVNode(_component_CCol, { md: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_CFormLabel, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.isEditing ? 'Новый' : 'Введите') + " пароль", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CInputGroup, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_CFormInput, {
                        modelValue: _ctx.user.password,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.user.password) = $event)),
                        type: _ctx.hiddenPassword ? 'password' : 'text',
                        onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.user.passwordInvalid = false)),
                        invalid: _ctx.user.passwordInvalid
                      }, null, 8, ["modelValue", "type", "invalid"]),
                      _createVNode(_component_CButton, {
                        type: "button",
                        color: "secondary",
                        variant: "outline",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.hiddenPassword = !_ctx.hiddenPassword)),
                        class: "d-flex flex-row justify-content-center align-items-center rounded-end"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.hiddenPassword)
                            ? (_openBlock(), _createBlock(_component_BIconEyeFill, {
                                key: 0,
                                class: "bootstrap-icon"
                              }))
                            : (_openBlock(), _createBlock(_component_BIconEyeSlashFill, {
                                key: 1,
                                class: "bootstrap-icon"
                              }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CFormFeedback, { invalid: "" }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_CCol, { md: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_CFormLabel, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Подтвердите" + _toDisplayString(_ctx.isEditing ? ' новый' : '') + " пароль", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CInputGroup, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_CFormInput, {
                        modelValue: _ctx.user.passwordConfirmation,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.passwordConfirmation) = $event)),
                        type: _ctx.hiddenPasswordConfirmation ? 'password' : 'text',
                        onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.user.passwordConfirmationInvalid = false)),
                        invalid: _ctx.user.passwordConfirmationInvalid
                      }, null, 8, ["modelValue", "type", "invalid"]),
                      _createVNode(_component_CButton, {
                        type: "button",
                        color: "secondary",
                        variant: "outline",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.hiddenPasswordConfirmation = !_ctx.hiddenPasswordConfirmation)),
                        class: "d-flex flex-row justify-content-center align-items-center rounded-end"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.hiddenPasswordConfirmation)
                            ? (_openBlock(), _createBlock(_component_BIconEyeFill, {
                                key: 0,
                                class: "bootstrap-icon"
                              }))
                            : (_openBlock(), _createBlock(_component_BIconEyeSlashFill, {
                                key: 1,
                                class: "bootstrap-icon"
                              }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CFormFeedback, { invalid: "" }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        (_ctx.validationErrors !== null)
          ? (_openBlock(), _createBlock(_component_CAlert, {
              key: 0,
              color: "danger",
              class: "d-flex align-items-center mt-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CIcon, {
                  icon: "cil-burn",
                  class: "flex-shrink-0 me-4",
                  width: "24",
                  height: "24"
                }),
                _createElementVNode("div", {
                  innerHTML: _ctx.validationErrors.innerHTML
                }, null, 8, _hoisted_15)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_CButton, {
            type: "submit",
            color: "primary",
            disabled: _ctx.savingLoading
          }, {
            default: _withCtx(() => [
              (_ctx.savingLoading)
                ? (_openBlock(), _createBlock(_component_CSpinner, {
                    key: 0,
                    size: "sm",
                    class: "me-2"
                  }))
                : (_openBlock(), _createBlock(_component_CIcon, {
                    key: 1,
                    icon: "cil-save",
                    class: "me-2"
                  })),
              _hoisted_17
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 32))
}